// extracted by mini-css-extract-plugin
module.exports = {"booking":"ErrorModal_booking__3-U3j","notification":"ErrorModal_notification__mVNfZ","description":"ErrorModal_description__3sz9i","button":"ErrorModal_button__2sne4"};